<template>
  <div v-if="classroom">
    <div class="title is-4">
      <span>{{ classroom.course.name }}</span>
      <div class="buttons are-small is-pulled-right">
        <div
          class="button is-rounded is-primary"
          @click="$emit('edit_classroom', classroom)"
        >
          <span class="icon">
            <i class="fa fa-edit"></i>
          </span>
          <span>{{ $t("edit") }}</span>
        </div>
        <div class="button is-info is-rounded" @click="save_scores">
          <span class="icon">
            <i class="fa fa-save"></i>
          </span>
          <span>{{ $t("save scores") }}</span>
        </div>
      </div>
    </div>

    <div class="subtitle is-5 mb-0">
      {{ classroom.professor.first_name }}
      {{ classroom.professor.first_surname }}
    </div>
    <div class="subtitle is-5">
      {{ classroom.period.name }}
    </div>
    <div class="title is-5 mt-5 mb-1">{{ $t("classroom settings") }}</div>
    <div class="columns">
      <div class="column">
        <span class="icon">
          <i class="fa fa-globe"></i>
        </span>
        <span
          class="is-size-6"
          v-if="
            classroom &&
            classroom.settings &&
            classroom.settings.virtual_classroom_url
          "
        >
          <a target="_blank" :href="classroom.settings.virtual_classroom_url">{{
            classroom.settings.virtual_classroom_url
          }}</a>
        </span>
        <span class="is-size-6 has-text-warning" v-else>{{
          $t("no virtual classroom set yet")
        }}</span>
      </div>
      <!-- <div class="column"></div> -->
    </div>

    <!-- <pre>{{ classroom.settings }}</pre> -->
    <div class="title is-5">{{ $t("students") }}</div>

    <div v-if="classroom.settings && classroom.settings.stages">
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li data-tab="stage_general" @click="change_active_tab($event, this)">
            <a>
              <i class="info icon" aria-hidden="true"></i>
              <span>{{ $t("general") }}</span>
            </a>
          </li>
          <li
            :data-tab="'stage_' + sidx"
            @click="change_active_tab($event, this)"
            v-for="(stage, sidx) in classroom.settings.stages || []"
            :key="sidx"
          >
            <a>
              <i class="book icon" aria-hidden="true"></i>
              <span>{{ stage.name }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="is-hidden" data-tab="stage_general">
          <table
            class="table is-fullwidth"
            v-if="
              classroom &&
              classroom.student_list &&
              classroom.student_list.length
            "
          >
            <thead>
              <tr>
                <th>{{ $t("id") }}</th>
                <th>{{ $t("student") }}</th>
                <th
                  v-for="(stage, sidx) in classroom.settings.stages || []"
                  :key="sidx"
                >
                  {{ stage.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, iidx) in classroom.student_list" :key="iidx">
                <td>{{ student.id_card_number }}</td>
                <td>
                  {{ student.name }}
                </td>
                <td
                  v-for="(stage, sidx) in classroom.settings.stages || []"
                  :key="sidx"
                >
                  <div class="field">
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        ref="score_input"
                        readonly
                        :data-student_id="student.student_id"
                        :data-course_id="classroom.course_id"
                        :data-period_id="classroom.period_id"
                        :data-professor_id="classroom.professor_id"
                        :data-stage_id="stage.id"
                        data-activity_id="stage_total"
                        :placeholder="$t('score')"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="is-hidden"
          :data-tab="'stage_' + sidx"
          v-for="(stage, sidx) in classroom.settings.stages || []"
          :key="sidx"
        >
          <table
            class="table is-fullwidth"
            v-if="
              classroom &&
              classroom.student_list &&
              classroom.student_list.length
            "
          >
            <thead>
              <tr>
                <th>{{ $t("id") }}</th>
                <th>{{ $t("student") }}</th>
                <th
                  v-for="(activity, aidx) in stage.activities || []"
                  :key="aidx"
                >
                  {{ activity.name }}
                </th>
                <th>{{ $t("total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, iidx) in classroom.student_list" :key="iidx">
                <td>{{ student.id_card_number }}</td>
                <td>
                  {{ student.name }}
                </td>
                <td
                  v-for="(activity, aidx) in stage.activities || []"
                  :key="aidx"
                >
                  <div class="field">
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        ref="score_input"
                        :data-student_id="student.student_id"
                        :data-course_id="classroom.course_id"
                        :data-period_id="classroom.period_id"
                        :data-professor_id="classroom.professor_id"
                        :data-stage_id="stage.id"
                        :data-activity_id="activity.id"
                        :placeholder="$t('score')"
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="field">
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        ref="score_input"
                        :data-student_id="student.student_id"
                        :data-course_id="classroom.course_id"
                        :data-period_id="classroom.period_id"
                        :data-professor_id="classroom.professor_id"
                        :data-stage_id="stage.id"
                        data-activity_id="stage_total"
                        :placeholder="$t('total')"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li data-tab="stage_general" @click="change_active_tab($event, this)">
            <a>
              <i class="info icon" aria-hidden="true"></i>
              <span>{{ $t("general") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="is-hidden" data-tab="stage_general">
          <table
            class="table is-fullwidth"
            v-if="
              classroom &&
              classroom.student_list &&
              classroom.student_list.length
            "
          >
            <thead>
              <tr>
                <th>{{ $t("id") }}</th>
                <th>{{ $t("student") }}</th>
                <th
                  v-for="(stage, sidx) in classroom.settings.stages || []"
                  :key="sidx"
                >
                  {{ stage.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, iidx) in classroom.student_list" :key="iidx">
                <td>{{ student.id_card_number }}</td>
                <td>
                  {{ student.name }}
                </td>
                <td
                  v-for="(stage, sidx) in classroom.settings.stages || []"
                  :key="sidx"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  post,
  success_message,
  error_message,
  format_currency,
  change_active_tab,
  input_alert,
} from "@/utils";
import ClassroomDetail from "./ClassroomDetail.vue";
import { groupBy } from "lodash";

export default {
  name: "ClassroomDetail",
  components: { ClassroomDetail },
  data() {
    return {
      classroom: null,
    };
  },
  computed: {},
  methods: {
    change_active_tab,
    set_classroom(classroom) {
      let v = this;
      v.classroom = null;
      // let inputs = window.jQuery(v.$refs.score_input);
      // inputs.each(function () {
      //   let input = window.jQuery(this);
      //   input.val("");
      // });
      get("/professor-portal/classroom", { uuid: classroom.uuid })
        .then((response) => {
          v.classroom = response;

          setTimeout(() => {
            window.jQuery(".tabs li:first").click();
            v.set_scores();
          }, 300);
        })
        .catch((error) => {
          error_message(error);
        });
    },
    refresh() {
      let v = this;
      if (v.classroom) {
        get("/professor-portal/classroom", {
          uuid: v.classroom.uuid,
        })
          .then((response) => {
            v.classroom = response;
          })
          .catch((error) => {
            error_message(error);
          });
      }
    },
    save_scores() {
      let v = this;
      let scores = [];
      let inputs = window.jQuery(v.$refs.score_input);
      inputs.each(function () {
        let input = window.jQuery(this);
        // if (input.val()) {
        scores.push({
          student_id: input.data("student_id"),
          course_id: input.data("course_id"),
          period_id: input.data("period_id"),
          professor_id: input.data("professor_id"),
          activity_id: input.data("activity_id"),
          stage_id: input.data("stage_id"),
          score: input.val(),
        });
        // }
      });

      post("/professor-portal/classroom/scores", { scores: scores })
        .then(() => {
          success_message(v.$t("scores saved successfully"));
        })
        .catch((error) => {
          error_message(error);
        });
      // if (scores.length > 0) {
      //   v.$emit("save_scores", stage, scores);
      // } else {
      //   v.$emit("show_message", "No scores to save");
      // }
    },
    set_scores() {
      let v = this;
      let inputs = window.jQuery(v.$refs.score_input);
      inputs.each(function () {
        let input = window.jQuery(this);
        let course_id = input.data("course_id");
        let period_id = input.data("period_id");
        let professor_id = input.data("professor_id");
        let stage_id = input.data("stage_id");
        let activity_id = input.data("activity_id");
        let student_id = input.data("student_id");
        if (v.classroom.scores) {
          let trgt_score = v.classroom.scores.find((s) => {
            return (
              s.student_id == student_id &&
              s.course_id == course_id &&
              s.period_id == period_id &&
              s.professor_id == professor_id &&
              s.stage_id == stage_id &&
              s.activity_id == activity_id
            );
          });
          if (trgt_score) input.val(trgt_score.score);
        }
      });
    },
    clear() {
      let v = this;
      v.classroom = null;
      let inputs = window.jQuery(v.$refs.score_input);
      inputs.each(function () {
        let input = window.jQuery(this);
        input.val("");
      });
    },
  },
};
</script>

<style scoped></style>
